import { registerOverlayResetHandler } from '../../shared/ports/sessionResetPort';
import { useCustomerOverlayStore } from '../store/useCustomerOverlayStore';

registerOverlayResetHandler(() => {
  useCustomerOverlayStore.getState().resetAll();
});
